import type { ReactNode, SVGProps } from 'react'

type Props = SVGProps<SVGSVGElement> & { size?: number }
const paths: Record<string, ReactNode> = {
  ArrowLeft: <><path d="m15 18-6-6 6-6"/><path d="M9 12h10"/></>,
  Bird: <><path d="M16 7h.01"/><path d="M3.4 18H12a8 8 0 0 0 8-8V7l-3 2-2-5-3 7H5a3 3 0 0 0-3 3c0 1.7 1.4 4 3.4 4Z"/><path d="m7 18-2 3"/><path d="m12 18 2 3"/></>,
  Camera: <><path d="M14.5 4 16 7h3a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h3l1.5-3Z"/><circle cx="12" cy="13" r="3"/></>,
  ChevronRight: <path d="m9 18 6-6-6-6"/>,
  CircleAlert: <><circle cx="12" cy="12" r="10"/><path d="M12 8v4"/><path d="M12 16h.01"/></>,
  ClipboardList: <><rect x="5" y="4" width="14" height="17" rx="2"/><path d="M9 4V2h6v2"/><path d="M9 10h6M9 14h6M9 18h4"/></>,
  FileDown: <><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z"/><path d="M14 2v6h6M12 12v6m-3-3 3 3 3-3"/></>,
  Image: <><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-5-5L5 21"/></>,
  Mic: <><path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2M12 19v3M8 22h8"/></>,
  Users: <><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/></>,
  Pencil: <><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/></>,
  Plus: <><path d="M12 5v14M5 12h14"/></>,
  Save: <><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2Z"/><path d="M17 21v-8H7v8M7 3v5h8"/></>,
  Search: <><circle cx="11" cy="11" r="7"/><path d="m20 20-4-4"/></>,
  Sparkles: <><path d="m12 3-1.7 3.5L7 8l3.3 1.5L12 13l1.7-3.5L17 8l-3.3-1.5Z"/><path d="m5 14-.9 2L2 17l2.1 1L5 20l.9-2L8 17l-2.1-1Z"/></>,
  Trash2: <><path d="M3 6h18M8 6V4h8v2M19 6l-1 15H6L5 6M10 11v6M14 11v6"/></>
}

function makeIcon(name: string) {
  return function Icon({ size = 24, ...props }: Props) {
    return <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>{paths[name]}</svg>
  }
}

export const ArrowLeft = makeIcon('ArrowLeft')
export const Bird = makeIcon('Bird')
export const Camera = makeIcon('Camera')
export const ChevronRight = makeIcon('ChevronRight')
export const CircleAlert = makeIcon('CircleAlert')
export const ClipboardList = makeIcon('ClipboardList')
export const FileDown = makeIcon('FileDown')
export const Image = makeIcon('Image')
export const Mic = makeIcon('Mic')
export const Users = makeIcon('Users')
export const Pencil = makeIcon('Pencil')
export const Plus = makeIcon('Plus')
export const Save = makeIcon('Save')
export const Search = makeIcon('Search')
export const Sparkles = makeIcon('Sparkles')
export const Trash2 = makeIcon('Trash2')
